<div [ngClass]="!(isHandset$ | async) ? 'tool' : 'tool-mobile'" class="fs-21 fw-500 primary-color">
  <img src="{{ toolImgSrc }}" alt="{{ toolImgAlt }}" />
  {{ toolTitle }}
  <div class="icons">
    <img src="{{ icon }}" *ngFor="let icon of toolIcons; let index = index" alt="{{ toolAlts[index] }}" />
  </div>
</div>
